import { PropertiesPage } from '@/modules/properties';

export default PropertiesPage;
